import React from 'react';
import { createRoot } from 'react-dom/client';
import { formatClocks, formatTime } from '@/lib/utils';

function line(prefix, item, index) {
  const start = formatTime(item.start_time);
  const end = formatTime(item.end_time);
  const when = start && end ? ` (${start}–${end})` : '';
  return (
    <li key={`${prefix}-${item.course_id || index}`}>
      {prefix}: {formatClocks(item.course_name) || item.course_name || 'Veranstaltung'}{when}
    </li>
  );
}

export function CollisionWarningDialog({ detail, onBack, onSave }) {
  const rooms = detail?.room_conflicts || [];
  const teachers = detail?.teacher_conflicts || [];
  return (
    <div
      className="absolute inset-0 z-[80] flex items-center justify-center bg-black/40 p-4"
      data-testid="schedule-collision-dialog"
    >
      <div role="dialog" aria-labelledby="schedule-collision-title" className="w-full max-w-md rounded-lg bg-white p-4 shadow-lg">
        <h2 id="schedule-collision-title" className="text-base font-semibold">Terminkollision erkannt</h2>
        <ul className="my-3 space-y-1 text-sm text-slate-700">
          {rooms.map((item, index) => line('Raum', item, index))}
          {teachers.map((item, index) => line('Lehrkraft', item, index))}
        </ul>
        <div className="flex justify-end gap-2">
          <button type="button" className="h-8 rounded border px-3 text-xs" onClick={onBack}>
            Zurück
          </button>
          <button
            type="button"
            className="h-8 rounded bg-emerald-600 px-3 text-xs font-semibold text-white"
            data-testid="schedule-collision-save"
            onClick={onSave}
          >
            Trotzdem speichern
          </button>
        </div>
      </div>
    </div>
  );
}

export function askCollisionOverride(detail) {
  return new Promise((resolve) => {
    const host = document.createElement('div');
    const parent = document.querySelector('[role="dialog"][data-state="open"]') || document.body;
    parent.appendChild(host);
    const root = createRoot(host);
    const finish = (ok) => {
      root.unmount();
      host.remove();
      resolve(ok);
    };
    root.render(
      <CollisionWarningDialog detail={detail} onBack={() => finish(false)} onSave={() => finish(true)} />,
    );
  });
}

export async function retryOnCollision(request, retry) {
  try {
    return await request();
  } catch (error) {
    const detail = error?.response?.data?.detail;
    if (error?.response?.status !== 409 || detail?.code !== 'schedule_collision') throw error;
    const ok = await askCollisionOverride(detail);
    if (!ok) return null;
    return retry();
  }
}
